import { Button, Input } from 'antd';
import type { FC } from 'react';

import { Send } from '@shared/assets/icons/components';
import chatInputStyles from '@modules/dialogs/ui/chat-window/ui/chat-input/chat-input.module.scss';

import styles from '../agent-test-chat.module.scss';

interface AgentTestInputProps {
  value: string;
  placeholder: string;
  isSending: boolean;
  onChange: (value: string) => void;
  onSend: () => void;
}

export const AgentTestInput: FC<AgentTestInputProps> = ({
  value,
  placeholder,
  isSending,
  onChange,
  onSend,
}) => (
  <div className={styles.input}>
    <div className={chatInputStyles.form}>
      <Input
        value={value}
        onChange={(event) => onChange(event.target.value)}
        placeholder={placeholder}
        className={chatInputStyles.textarea}
        onPressEnter={(event) => {
          event.preventDefault();
          if (isSending) return;
          onSend();
        }}
      />
      <Button
        icon={<Send />}
        onClick={onSend}
        disabled={!value.trim() || isSending}
        loading={isSending}
        className={chatInputStyles.submit}
      />
    </div>
  </div>
);
